import Vue from 'vue'
import Vuex from 'vuex'

import userInfo from './user/UserInfo'
import language from "./country/language";
import common from "./modules/common"
import memberDetail from "@/store/user/memberDetail";
import itemCategory from "@/store/item/itemCategory";
import competitionCategory from "@/store/competition/competitionCategory";

Vue.use(Vuex)


export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        userInfo,
        language,
        common,
        memberDetail,
        itemCategory,
        competitionCategory,
    }
})
